import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import ShareSomethingForm from '../components/SubmissionForm';
import FormFooter from '../components/FormFooter';
import HeaderBar from '../components/HeaderBar';
import { ValidatorForm } from 'react-material-ui-form-validator';

/*eslint no-mixed-operators: "off"*/

const styles = theme => ({
	marginWithFooter: {
		marginBottom: (12 * theme.spacing.unit)
	}
});

// TODO - move to utility
const convertToBase64 = file => new Promise((resolve, reject) => {
	let reader = new FileReader();
	
	reader.onloadend = function() {
		let base64data = reader.result;
		resolve(base64data);
	}
	// TODO - add on error handle
	reader.readAsDataURL(file); 
});

class ShareSomething extends Component {
	constructor(props, context) {
		super(props, context);
		
		// sentiment setup
		let sentiments = {
			uncertain: ['sad', 'scared', 'frustrated', 'angry', 'bullied', 'mad', 'ok'],
			negative: ['angry', 'scared', 'bullied', 'sad', 'frustrated', 'mad', 'ok']
		}
		let initialVals = [];

		this.category = "category" in props.match.params && props.match.params.category;
		if(this.category && this.category !== "positive") {
			this.triggerVal = 'something else...';
			this.sentimentValues = sentiments[this.category];
			this.sentimentMinValues = this.getMinifiedValues(this.sentimentValues);
			initialVals = this.sentimentMinValues;
		}

		let {locationKey, sourceType, embeddedOn} = props;
		this.state = {
			sentimentValues: initialVals,
			identify: false,
			concernOther: false,
			disableSubmit: false,

			// TODO - these should persist values if recaptcha reloaded
			// These state values are sent to api handler; if you add additional state,
			// put it in the right location here plus down in send handler, make sure 
			// to remove from body if not meant to be sent with form submission to prevent
			// leakage
			sentiment: null,
			identifyName: '',
			identifyEmail: '',
			identifyPhone: '',
			identifyEmailConf: '',
			concernOtherDescription: '',
			description: '',
			recaptchaToken: null,
			sourceType,
			embeddedOn,
			locationKey,
			attachments: []
		}
	}

	componentDidUpdate = prevProps => {
		let update = {};
		if (this.props.locationKey !== prevProps.locationKey) {
			update.locationKey = this.props.locationKey
		}
		if (this.props.embeddedOn !== prevProps.embeddedOn) {
			update.embeddedOn = this.props.embeddedOn
		}
		if (this.props.sourceType !== prevProps.sourceType) {
			update.sourceType = this.props.sourceType
		}

		if(Object.keys(update).length) {
			this.setState(update);
		}
	}

	getMinifiedValues = values => {
		let minValues = values.slice(0, 2);
		minValues.push(this.triggerVal);
		return minValues;
	}	

	onCloseTap = () => {
		// TODO - add discard confirmation
		const {messageSource, isTip} = this.props;

		// Don't want to backup here because it'll mess up the view 
		// if reused without reloading iframe
		if(isTip && messageSource) {
			messageSource.postMessage({
				type: "APP_CONTROL",
				action: "close"
			}, "*");

		} else {
			this.props.history.goBack();
		}
	}
	
	onIdentifyTap = event => {
		this.setState({identify: event.target.checked});
	}
	
	onConcernOtherTap = event => {
		this.setState({concernOther: event.target.checked});
	}
	
	onSelectFileTap = event => {
		if("files" in event.target && event.target.files.length) {
			const files = event.target.files;
			let results = [];

			// files are a files list & don't support map but is array-like
			for(let i = 0; i < files.length; i++) {
				// TODO - confirm persists name
				results.push(convertToBase64(files[i]));
			}

			Promise.all(results)
				.then(b64Files => new Promise((resolve) => {
					let fileObjs = b64Files.map((data, idx) => ({
						name: files[idx].name,
						size: files[idx].size,
						lastModified: files[idx].lastModified,
						data
					}));

					let attachments = this.state.attachments.concat(fileObjs);
					// For single attachments
					// let attachments = fileObjs;
					this.setState({attachments});
					resolve('success');
				}))
				.catch(error => console.error(error));
		}
	}
	
	onSendTap = event => {
		this.setState({disableSubmit: true});
		let category = this.category || "";
		let {recaptchaToken} = this.state;
		let body = this.getFieldValues();
		console.info(this.state);
		console.info(body);
		if(this.checkEmpty(body)) {
			this.setState({disableSubmit: false});
			return;
		}
		// if(process.env.NODE_ENV !== 'development') {

			let options = {
				"headers": {
					"content-type": "application/json",
					"x-csrf-token": recaptchaToken
				},
				"method": "POST",
				"body": JSON.stringify(body)
			}
			let apiUrl = `/api/v1/share`;

			fetch(apiUrl, options)
				.then(response => {
					this.setState({disableSubmit: false});

					if(response.ok) {
						return response.json();

					} else {
						console.error(`${response.status} ${response.statusText}`);
						return {};
					}

				})
				.then(json => {
					console.info(json);
					this.props.history.replace(`/thanks/${category}`);
				})
				.catch(error => {
					this.setState({disableSubmit: false});
					console.error(`${error.name} ${error.msg}`);
					// this.props.history.goBack();
				});

		// } else {
		// 	console.warn('Local dev - skipping failing call to API gateway');
		// 	console.info(body);
		// 	this.setState({disableSubmit: false});
		// 	this.props.history.replace(`/thanks/${category}`);
		// }
	}

	checkEmpty = body => {
		for (let key in body) {
			if(['locationKey', 'messageSource', 'embeddedOn'].indexOf(key) === -1) {
				if((body[key] instanceof Array && body[key].length) || (!(body[key] instanceof Array) && body[key])) {
					return false
				}
			}
		}
		return true;
	}

	// Copy form values into "body", itemized ones items from state not meant to send
	getFieldValues = () => {
		let {sentimentValues, identify, concernOther, disableSubmit, recaptchaToken, ...body} = this.state;

		// Override optional values if checkbox has been unchecked
		let identifyOverrides = {};
		let concernOtherOverrides = {};

		if(!identify) {
			identifyOverrides = {
				identifyName: '',
				identifyEmail: '', 
				identifyEmailConf: '', 
				identifyPhone: '', 
			};
		}

		if(!concernOther) {
			concernOtherOverrides = {
				concernOtherDescription: ''
			};
		}

		body = Object.assign({}, body, concernOtherOverrides, identifyOverrides);

		return body;
	}

	onSentimentChange = event => {
		let sentiment = event.target.value;

		// expand list
		if(this.state.sentimentValues.indexOf(sentiment) > 1) {
			// reset selection if triggerVal selected
			sentiment = sentiment !== this.triggerVal && sentiment || null;
			this.setState({
				sentimentValues: this.sentimentValues,
				sentiment
			})
		
		} else {
			this.setState({sentiment});
			// Disabled collapsing once expanded
			// this.setState({
			// 	sentimentValues: this.sentimentMinValues,
			// 	sentiment
			// });
		}
	}

	onFieldChange = event => {
		let target = event.target,
			value = target.value;

		if (target.type === "checkbox") {
			value = target.checked;
		}

		this.setState({[target.name]: value});
	}

	onRecaptchaChange = token => {
		console.log("Recaptcha token length: ", token.length);
		// console.info(token);
		this.setState({recaptchaToken: token});
	}

	render() {
		let {classes, isTip, recaptchaRef} = this.props;
		let title, placeholder;
		let descriptionLabel = "What's happening?";
		let notGood = (this.category && this.category !== 'positive');
		// need null so attachement count is blank when 0
		let attachedCount = this.state.attachments.length || null;

		if(isTip) {
			title = "Something Suspicious?";
			placeholder = "Please enter as much detail about your concern as possible."

		} else {
			title = 'What\'s ' + (this.category === 'positive' && 'GOOD' || 'WRONG');
			placeholder = "Please enter as much detail as possible."
		}

		return (
			<ValidatorForm noValidate
				autoComplete="off"
				ref="form"
				onSubmit={this.onSendTap}
				onError={errors => console.log(errors)}
			>
				<HeaderBar 
					category={isTip ? "tip" : this.category} 
					title={title}
					closeHandler={this.onCloseTap}
					recaptchaRef = {recaptchaRef}
					recaptchaHandler={this.onRecaptchaChange}
				/>
				<div className={classes.marginWithFooter}>
					<ShareSomethingForm 
						category={this.category}
						descriptionLabel={descriptionLabel}
						placeholder={placeholder}
						sentimentProps={{
							values: this.state.sentimentValues,
							selection: this.state.sentiment,
							changeHandler: this.onSentimentChange,
							visible: notGood,
						}} 
						identifyHandler={this.onIdentifyTap} 
						concernOtherHandler={this.onConcernOtherTap}
						fieldChangeHandler={this.onFieldChange}
						showConcernOther={notGood}

						description={this.state.description}
						identify={this.state.identify}
						identifyName={this.state.identifyName}
						identifyEmail={this.state.identifyEmail}
						identifyEmailConf={this.state.identifyEmailConf}
						identifyPhone={this.state.identifyPhone}
						concernOther={this.state.concernOther} 
						concernOtherDescription={this.state.concernOtherDescription} 
					/>
				</div>
				<FormFooter
					category={isTip ? "tip" : this.category}
					attachedCount={attachedCount}
					disableSubmit={this.state.disableSubmit}
					selectFileHandler={this.onSelectFileTap} />
			</ValidatorForm>
		);
	}
}

ShareSomething.propTypes = {
	isTip: PropTypes.bool,
	sourceType: PropTypes.string,
	match: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	messageSource: PropTypes.object,
	embeddedOn: PropTypes.string
};
// sendHandler={this.onSendTap}
export default withStyles(styles)(ShareSomething);
